module.exports = __webpack_public_path__ + "static/media/device-usb.ae308ed7.png";